import { createApp } from "vue";
import "@/style.css";
import App from "@/App.vue";
import Router from "@/router";
import ElementPlus from "element-plus";
import ViewUIPlus from "view-ui-plus";
import "element-plus/theme-chalk/index.css";
import "view-ui-plus/dist/styles/viewuiplus.css";
import { createHead } from "@vueuse/head";

const app = createApp(App);
let router = Router;
app.use(router);
app.use(ElementPlus);
app.use(ViewUIPlus);
app.use(createHead());

(async () => {
  await router.isReady();
  app.mount("#app");
})();
